import { PropsWithChildren, forwardRef } from "react";
import { Stack } from "@mui/material";

interface Props {
  color: string;
}

export const InfoBox = forwardRef<HTMLDivElement, PropsWithChildren<Props>>(
  ({ color, children }, ref) => {
    return (
      <Stack
        data-testid="infobox-stack-parent"
        gap={1.2}
        ref={ref}
        sx={theme => ({
          border: `1px solid ${color}`,
          opacity: 0.9,
          position: "relative",
          right: 0,
          p: 1,
          borderRadius: 0.5,
          backgroundColor: "#000000",
          ...theme.applyStyles("light", {
            backgroundColor: "#ffffff"
          })
        })}
      >
        <div>{children}</div>
      </Stack>
    );
  }
);
